/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { apiClient } from './api';
import { handleError } from './error';
import type { AppDispatch, RootState } from '../reducers';
import type { ApiResponse } from '../types/api';
import type { Suggestion } from '../types/search';
import type { Workgroup } from '../types/workgroup';
import type { IndustrySector } from '../types/common';

type GetState = () => RootState;
type SurveyUserSearchResult = { users: Suggestion[]; workgroups: Workgroup[] } | Suggestion[];

export function searchOrganizationByName(escapedString: string) {
  return apiClient.get<ApiResponse<Suggestion[]>>(`o/common/organization/search?q=${escapedString}`)
    .then(response => response.data.data)
}

export function searchUserByOrganization(escapedString: string, organizationId: string) {
  return apiClient.get<ApiResponse<Suggestion[]>>(`users/organization/${organizationId}/search?s=${escapedString}`)
    .then(response => response.data.data.map(d => {
      d.name = `${d.firstName} ${d.surname}`;
      return d;
    }));
}

export function searchUserByInitiative(escapedString: string, initiativeId: string) {
  return apiClient.get<ApiResponse<Suggestion[]>>(`users/initiative/${initiativeId}/search?s=${escapedString}`)
    .then(response => response.data.data.map(d => {
      d.name = `${d.firstName} ${d.surname}`;
      return d;
    }));
}

export function searchUserBySurvey(escapedString: string, surveyId: string) {
  return apiClient.get<ApiResponse<SurveyUserSearchResult>>(`users/survey/${surveyId}/search?s=${escapedString}`).then((response) => response.data.data);
}

export const loadUNSDGMap = () => (dispatch: AppDispatch, getState: GetState) => {
  const myState = getState().UNSDGMap;
  const isLoading = myState.loading === true;
  const isLoaded = myState.loaded === true;
  if (isLoaded || isLoading) {
    return;
  }
  dispatch({
    type: actionTypes.LOADING_UN_SDG_MAP
  });

  return apiClient.get<ApiResponse<NonNullable<RootState['UNSDGMap']['data']>>>('o/un/sdg')
    .then(response => dispatch({
      type: actionTypes.LOADED_UN_SDG_MAP,
      data: response.data.data
    }))
    .catch(handleError(dispatch, actionTypes.ERROR_UN_SDG_MAP));
}


export const loadIndustrySectors = () => (dispatch: AppDispatch, getState: GetState) => {
  const myState = getState().industrySectors;
  const isLoading = myState.loading === true;
  const isLoaded = myState.loaded === true;
  if (isLoaded || isLoading) {
    return;
  }
  dispatch({
    type: actionTypes.LOADING_INDUSTRY_SECTORS
  });

  return apiClient.get<ApiResponse<IndustrySector[]>>('o/common/industry-sectors')
    .then(response => dispatch({
      type: actionTypes.LOADED_INDUSTRY_SECTORS,
      data: response.data.data
    }))
    .catch(handleError(dispatch, actionTypes.ERROR_INDUSTRY_SECTORS));
}
